import axios from 'axios';
import { debounce, get } from 'lodash';
import { setSnackBarObj, setShowBeatLoader, setHideBeatLoader } from '../../reducers/Alerts';
import { dispatch, getState } from '../../config/store';
import { getCompanyFromGlobalStatesByCompanyId } from '../watchlist/WatchlistHelpers';
import { setSelectedWatchlist } from '../../reducers/Watchlist';
import { setSidebarToggle } from '../../reducers/ThemeOptions';
import { setReacntIdAndDocumentType } from 'global/GlobalActions';
import { getSelectedRegionId } from 'utils/helpers';
import { setIsGetFreshWatchlistCategoriesData } from 'reducers/WatchlistDialog';

let getCompanyFromEsCallToken = null;
export let addToWatchlistTickersStatuses = null;

export const getUserWatchlistTickers = async () => {
  try {
    const response = await axios.get('/api/get_user_watchlist');
    if (response.data?.data?.length) {
      return response.data.data.map(v => v.ticker);
    }
  } catch (e) {
    console.log('error', e);
  }
};

export const addTickerToWatchlist = (tickerAndCompArr, selectedCategories, isFromAddWatchlistDialog = false) => {
  return async dispatch => {
    try {
      !isFromAddWatchlistDialog && dispatch(setShowBeatLoader());
      const response = await axios.post('/api/save_user_watchlist', {
        delete_old_values: false,
        watchlistGroupId: selectedCategories,
        tickerAndCompArr,
      });
      const resData = get(response, 'data', null);
      dispatch(setIsGetFreshWatchlistCategoriesData(true));
      if (resData && !resData.error) {
        if (isFromAddWatchlistDialog) {
          const addedTickers = resData.data?.added_tickers ?? [];
          const notAddedTickers = resData.data?.not_added_tickers ?? [];
          if (addedTickers.length || notAddedTickers.length) {
            addToWatchlistTickersStatuses = {
              addedTickers,
              notAddedTickers,
            };
            return true;
          } else dispatch(setSnackBarObj({ message: 'Unable to add Ticker in Watchlist', severity: 'error' }));
        } else {
          dispatch(setSnackBarObj({ message: 'Ticker added in Watchlist', severity: 'success' }));
          return true;
        }
      } else {
        dispatch(setSnackBarObj({ message: resData.message, severity: 'error' }));
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      !isFromAddWatchlistDialog && dispatch(setHideBeatLoader());
    }
  };
};

export const removeTickerFromWatchlist = company_id => {
  return async dispatch => {
    try {
      dispatch(setShowBeatLoader());
      const response = await axios.delete('/api/delete_user_watchlist', {
        params: {
          company_id,
        },
      });
      const responsePayload = get(response, 'data', null);
      dispatch(setIsGetFreshWatchlistCategoriesData(true));
      if (responsePayload && !responsePayload.error) {
        dispatch(setSnackBarObj({ message: 'Ticker removed from Watchlist', severity: 'info' }));
      } else {
        dispatch(setSnackBarObj({ message: 'Unable to removed Ticker from Watchlist', severity: 'error' }));
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      dispatch(setHideBeatLoader());
    }
  };
};

export const cancelGetCompanyFromEsCall = () => {
  if (getCompanyFromEsCallToken) {
    getCompanyFromEsCallToken.cancel();
    getCompanyFromEsCallToken = null;
  }
};

const getCompanyFromES = async (companyId, ticker) => {
  try {
    cancelGetCompanyFromEsCall();
    const cancelToken = axios.CancelToken.source();
    getCompanyFromEsCallToken = cancelToken;
    dispatch(setShowBeatLoader());
    const response = await axios.get('/api/get_company_info_from_ES', {
      params: {
        company_id: companyId ? companyId : undefined,
        ticker: ticker ? ticker : undefined,
        selected_region: getSelectedRegionId(getState().HomePage?.homePageRegion?.id) ?? 2,
      },
      cancelToken: cancelToken.token,
    });
    if (response?.data?.data) {
      const company = response.data.data;
      return {
        companyId: company.company_id,
        ticker: company.ticker ?? null,
        companyName: company.company_name ?? '',
        sector: company.sector ?? '',
        industry: company.industry ?? '',
        sourceName: company.source_name,
        flag: company.source_social_id,
      };
    }
  } catch (e) {
    console.log('error', e);
  } finally {
    getCompanyFromEsCallToken = null;
    dispatch(setHideBeatLoader());
  }
};

export const setCompany = debounce(async (compId, ticker) => {
  if (!compId && !ticker) return;
  let company = dispatch(getCompanyFromGlobalStatesByCompanyId(compId));
  if (company) {
    setReacntIdAndDocumentType(company);
  } else {
    company = await getCompanyFromES(compId, ticker);
  }
  if (company) {
    dispatch(setSidebarToggle(false));
    dispatch(setSelectedWatchlist(company));
  } else {
    dispatch(setSelectedWatchlist(null));
  }
}, 500);

export const stripTOorXFromEnd = ticker => {
  if (!ticker) return null;
  const endsWithTOorXPattern = /\.TO$|\.X$/;
  if (ticker.match(endsWithTOorXPattern)) {
    ticker = ticker.replace(endsWithTOorXPattern, '');
  }
  return ticker;
};
